import { SupportedLang } from './supportedLang';

const SUPPORTED_LANGS: readonly SupportedLang[] = Object.values(SupportedLang);

/**
 * Normalizes an arbitrary locale identifier (e.g. from Keycloak / OIDC
 * `locale` claim or a `ui_locales` query param) to one of the platform's
 * {@link SupportedLang} values.
 *
 * Accepts plain language codes (`en`, `fr`, `de`), BCP-47 tags
 * (`en-US`, `de-DE`, `fr-CH`), POSIX-style locales (`en_US`), mixed case,
 * and surrounding whitespace. Returns `null` for unknown/unsupported inputs
 * so callers can decide to keep the existing locale rather than fall back
 * to English.
 */
export const normalizeLocale = (raw: string | null | undefined): SupportedLang | null => {
  if (!raw) {
    return null;
  }

  const normalized = raw.trim().toLowerCase().replace('_', '-');
  if (!normalized) {
    return null;
  }

  const primary = normalized.split('-')[0];

  return SUPPORTED_LANGS.find((lang) => lang === primary) ?? null;
};
